module.exports = __webpack_public_path__ + "img/CAPTURE_TAUR_121.c45c3f55.jpg";